import {useState} from "react"

import { MDB_TYPES } from "@meddbriefer/scenario-data/constants"
import { useCheckList } from "./CheckListContext"

const INITIAL_STATE = { newID: "", newLabel: "" }

const AddSubPhase = ({index, phase}) => {
    const [state, setState] = useState(INITIAL_STATE)
    const [errMsg, setErrMsg] = useState("")

    const {uniqueIDs, uniqueLabels, insertRec} = useCheckList()

    const changeHandler = (event) => {
        const {id, value} = event.target
        setState(prevState => Object.assign({}, prevState, {[id]: value}))
    }

    const addHandler = (event) => {
        event.preventDefault()
        if ("" === state.newID) {
            setErrMsg("Please enter an ID")
        } else if ("" === state.newLabel) {
            setErrMsg("Please enter a label")
        } else if (uniqueIDs.includes(state.newID)) {
            setErrMsg("ID must be unique")
        } else if (uniqueLabels.includes(state.newLabel)) {
            setErrMsg("Label must be unique")
        } else {
            const newRec = {
                id: state.newID,
                type: MDB_TYPES.SUB_PHASE,
                label: state.newLabel,
                phase: phase,
                parentID: phase
            }
            insertRec(newRec, index)
            setState(INITIAL_STATE)
            setErrMsg("")
        }
    }

    return (
        <>
            <div className="add-item">
                Add new Sub-Section:
                <b> ID: </b> <input type="text" id="newID" value={state.newID} autoComplete="off" onChange={changeHandler} />
                <b> Label: </b> <input type="text" id="newLabel" value={state.newLabel} autoComplete="off" onChange={changeHandler} />
                <button className="add-btn" onClick={addHandler}>+</button>
            </div>
            <div className={errMsg === "" && "hidden"}>
                {errMsg}
            </div>
        </>
    )
}

export default AddSubPhase